import i18n from '@/api/i18n/i18n';

export const COLUMNS = [
  { field: 'user', title: i18n.t('relations.columns.user') },
  { field: 'email', title: i18n.t('relations.columns.email'), center: true },
  { field: 'skype', title: i18n.t('relations.columns.messengers'), center: true },
  { field: 'socNet', title: i18n.t('relations.columns.socialNetwork'), center: true },
];

export const CATEGORIES = {
  ESTABLISHED: {
    key: 'establishedContacts',
    title: 'Установленные контакты',
  },
  OTHER: {
    key: 'otherContacts',
    title: 'Неустановленные контакты',
  },
};

export const GROUPS = [
  { id: 0, groupName: 'Показать взаимосвязи контакта' },
  { id: 1, groupName: 'Показать переписку' },
  { id: 2, groupName: 'Показать карточку контакта' },
];

export const GROUPS_OTHER = [
  { id: 1, groupName: 'Показать переписку' },
  { id: 3, groupName: 'Привязать к контакту' },
];

export const TYPE_DETAILS = [
  { name: i18n.t('settings.typeDetails.counterparty'), id: 0 },
  { name: i18n.t('settings.typeDetails.formerEmployee'), id: 1 },
  { name: i18n.t('settings.typeDetails.suspicious'), id: 2 },
  { name: i18n.t('settings.typeDetails.probationPeriod'), id: 3 },
  { name: i18n.t('settings.typeDetails.employee'), id: 4 },
  { name: i18n.t('settings.typeDetails.specialAttention'), id: 5 },
];
